import {
  useMutation,
  useQueryClient,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { toast } from "sonner";
import type { SetToolsResponse } from "../types";
import { currentToolsQueryOptions } from "./get-current-tools";
import { entitlementsQueryOptions } from "./get-entitlements";
import { setTools } from "./set-tools";

export const useEntitlements = () =>
  useSuspenseQuery(entitlementsQueryOptions());

/** The end-user's currently provisioned selection + gateway (for rehydration). */
export const useCurrentTools = () =>
  useSuspenseQuery(currentToolsQueryOptions());

const pluralize = (count: number) => (count === 1 ? "" : "s");

export const useSetTools = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (tools: string[]): Promise<SetToolsResponse> => setTools(tools),
    meta: {
      errorMessage: "Unable to save your tools",
    },
    onSuccess: ({ tools }: SetToolsResponse) => {
      toast.success(`Saved ${tools.length} tool${pluralize(tools.length)}`);
      // Keep the rehydration source in sync so a reload reflects this save.
      queryClient.invalidateQueries({
        queryKey: currentToolsQueryOptions().queryKey,
      });
    },
  });
};
